// Unified async storage abstraction:
// - On native (iOS/Android): uses @capacitor/preferences (backed by UserDefaults / SharedPreferences)
// - On web: falls back to localStorage

import { isNative } from './platform';
import { Preferences } from '@capacitor/preferences';

export const secureStorage = {
  async get(key: string): Promise<string | null> {
    if (isNative()) {
      try {
        const { value } = await Preferences.get({ key });
        return value;
      } catch {
        return localStorage.getItem(key);
      }
    }
    return localStorage.getItem(key);
  },

  async set(key: string, value: string): Promise<void> {
    if (isNative()) {
      try {
        await Preferences.set({ key, value });
        return;
      } catch {
        // fall through to localStorage
      }
    }
    localStorage.setItem(key, value);
  },

  async remove(key: string): Promise<void> {
    if (isNative()) {
      try {
        await Preferences.remove({ key });
        return;
      } catch {
        // fall through to localStorage
      }
    }
    localStorage.removeItem(key);
  },

  async clear(): Promise<void> {
    if (isNative()) {
      try {
        await Preferences.clear();
        return;
      } catch {
        // fall through to localStorage
      }
    }
    localStorage.clear();
  },
};
